//引入
import { JSEncrypt } from "jsencrypt";

/*
 *@描述: 加密参数
 *@参数: 需要加密的参数
 *@作者: 金涛
 *@日期: 2022-06-24 18:42:27
 */
export function setEncryption(param) {
  // 后台给的公钥
  const publicKey =
    "MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAJRCxjG3dey5COyNnxRqDdQ9QrTi8QuWEap3TPEXiaIfkvlJ89ikUXbZV/slhsgRXoeC1DfqNFxYBMt0Ssr3oguRtFENwg5T3dQVCGE+nyxSyR7Pued7Z55Us+jGCyhqe8V2484Srhjmojd59ILtOPA22KBmucYYJ6WyDkMl+2LjAgMBAAECgYBFMWzCIzccBbdOf0HxCxXtKbIKLagFmkIgZpE4K54GVeoIAiWVxAppB0Jyaa8fjEurvrlAZ0OMnV+PfHSziSLMwN4kkx8MwIVAPLFmBwSJRCw/OrFXsgTUUb1HRr28ROpFTZi33HDAOWbhyEDBCewHE00q2ju3LE/QgKMmtoT0wQJBANUPGE+2+Nol+VY1dUY8M1y/vUSI41fY3GCs9eB2cr1zquzD9jsVkusIEThFkgUwRYBWisjMk+xfHABWxnX5C5MCQQCyJGGGwVi9Nmq5UdG8Vi5Whzwn+HddDdetNHScycyruLBTzc51T94ZaAERd/UEyKETlCl5pZr2Ev06THnHD/1xAkEAl/d5Vrpii27UhnoA2QTtebVFcZHV3n3OyqHzipPRyXGsM86eXYxIy51ocuOkgFDq8dxIh2rsA4ffOBqs2c62QwJAXbh0MsAf3pP1fAAGtu4kPNOzG1hF/AffUzmIrEAi1Kk64ywglWlqcLVd8oHIvzaKP9GwLFaq+xEsdnJrkwXfkQJBAKqH8uZ0x2qPSI7tXNmoXmAQFM/akyzDBl8p2thEhhzSg0LXXMFU+FhXGGgYzLaL9eXNgRCvC/Fdvksrmx0cCto=";
  let encryptor = new JSEncrypt(); // 新建JSEncrypt对象
  encryptor.setPublicKey(publicKey); // 设置公钥

  return encryptor.encrypt(JSON.stringify(param)); // 对密码进行加密
}
